<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商编码">
              <el-input v-model="q.agentCode" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="经销商名称">
              <el-input v-model="q.agentName" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="渠道">
              <brselectlazy category="sales_region"
                            v-model="q.channelCode"  :v="q.channelCode" :clearable="true"/>
            </el-form-item>
            <el-form-item label="召开人">
              <el-input v-model="q.conveneName" :clearable="true"></el-input>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item  label="运营会时间">
                  <el-date-picker type="date" placeholder="选择日期" v-model="q.weekTime"
                                  value-format="yyyy-MM-dd" style="width: 100%;">
                  </el-date-picker>
                </el-form-item>

                  <el-form-item label="省份">
                      <brselect category="YlSalesArea_chanpin" :v="q.provinceCode"  v-model="q.provinceCode" :clearable="true"></brselect>
                  </el-form-item>

              </div>
            </div>
          </el-collapse-transition>
        </el-form>


        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button
                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                @click="createdMeeting">新增网络运营会
            </el-button>
          </div>
        </div>
      </div>
      <!--查询end-->

      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            ref="ddtable"
            :data="tableData"
            stripe
            border
            style="width: 100%">
          <el-table-column
              type="index"
              width="60"
              label="序号"
              fixed >
          </el-table-column>
          <el-table-column
              prop="agentCode"
              label="经销商编码"
              width="100"
              fixed>
          </el-table-column>
          <el-table-column
              prop="agentName"
              label="经销商名称"
              width="200"
              :show-overflow-tooltip="true"
              fixed>
          </el-table-column>
          <el-table-column
              prop="channelCode"
              label="签约渠道"
              :show-overflow-tooltip="true"
              width="110">
            <template slot-scope="scope">
              {{scope.row.channelCode | dictname('fl_sales_region_qudao')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="provinceCode"
              label="省份"
              :show-overflow-tooltip="true"
              width="80">
            <template slot-scope="scope">
              {{scope.row.provinceCode | dictname('YlSalesArea_chanpin')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="conveneCode"
              label="召开人编码"
              width="100">
          </el-table-column>
          <el-table-column
              prop="conveneName"
              label="召开人名称"
              width="100">
          </el-table-column>
          <el-table-column
              prop="participants"
              label="参会人员"
              :show-overflow-tooltip="true"
              width="130">
          </el-table-column>
          <el-table-column
              prop="weekTime"
              label="运营会时间"
              :show-overflow-tooltip="true"
              width="110">
          </el-table-column>
          <el-table-column
              prop="monthOne"
              label="月份"
              width="80">
          </el-table-column>
          <el-table-column
              prop="fieldOne"
              label="领域一"
              width="90">
          </el-table-column>
          <el-table-column
              prop="monthTargetOne"
              label="本月目标(万)"
              width="90">
          </el-table-column>
          <el-table-column
              prop="monthExpectOne"
              label="本月预计达成（万）"
              width="110">
          </el-table-column>
          <el-table-column
              prop="completionRateOne"
              label="预测履约率（%）"
              width="100">
          </el-table-column>
          <el-table-column
              prop="detailOne"
               label="本月预测支撑明细"
               :show-overflow-tooltip="true"
               width="140">
          </el-table-column>
          <el-table-column
              prop="fieldTwo"
              label="领域二"
              width="90">
          </el-table-column>
          <el-table-column
              prop="monthTargetTwo"
              label="本月目标(万)"
              width="90">
          </el-table-column>
          <el-table-column
              prop="monthExpectTwo"
              label="本月预计达成（万）"
              width="110">
          </el-table-column>
          <el-table-column
              prop="completionRateTwo"
              label="预测履约率（%）"
              width="100">
          </el-table-column>
          <el-table-column
              prop="detailTwo"
              label="本月预测支撑明细"
              :show-overflow-tooltip="true"
              width="140">
          </el-table-column>
          <el-table-column
              prop="targetUserNum"
              label="目标用户个数"
              width="100">
          </el-table-column>
          <el-table-column
              prop="leijiUserNum"
              label="累计覆盖用户"
              width="100">
          </el-table-column>
          <el-table-column
              prop="yearUserNum"
              label="当年覆盖用户"
              width="100">
          </el-table-column>
          <el-table-column
              prop="leijiCoverage"
              label="累计覆盖率"
              width="100">
          </el-table-column>
          <el-table-column
              prop="yearCoverage"
              label="当年覆盖率"
              width="100">
          </el-table-column>
          <el-table-column
              prop="noCoveredNoloudUserNum"
              label="未覆盖且无漏斗用户个数"
              width="140">
          </el-table-column>
          <el-table-column
              prop="weekPlan"
              label="本周行动计划"
              width="140"
          >
            <template #default="{row}">
              <el-tooltip
                  placement="top"
                  :popper-class="'custom-tooltip'">
                <div slot="content" style="white-space: pre-line;">{{ row.weekPlan }}</div>
                <span>{{row.weekPlan}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              prop="handInput"
              label="手工录入"
              :show-overflow-tooltip="true"
              width="120"
          >
          </el-table-column>
          <el-table-column
              prop="inventoryDigestionPlan"
              label="库存消化行动方案"
              :show-overflow-tooltip="true"
              width="150"
          >
          </el-table-column>
          <el-table-column
              prop="threeMonthProject"
              label="未来3个月内招标项目"
              :show-overflow-tooltip="true"
              width="160"
          >
          </el-table-column>
          <el-table-column
              prop="monthProject"
              label="本月开标项目"
              :show-overflow-tooltip="true"
              width="150"
          >
          </el-table-column>
          <el-table-column
              prop="activityType"
              label="活动类型"
              :show-overflow-tooltip="true"
              width="130"
          >
          </el-table-column>
          <el-table-column
              prop="activityPlan"
              label="行动计划"
              :show-overflow-tooltip="true"
              width="130"
          >
          </el-table-column>
          <el-table-column
              prop="activityTime"
              label="预计召开时间"
              :show-overflow-tooltip="true"
              width="130"
          >
          </el-table-column>
          <el-table-column
              prop="trainingproduct"
              label="培训产品"
              :show-overflow-tooltip="true"
              width="130"
          >
          </el-table-column>
          <el-table-column
              prop="cdate"
              label="创建日期"
              :show-overflow-tooltip="true"
              width="140">
          </el-table-column>
          <el-table-column
              prop="cuname"
              label="创建人"
              width="80">
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="220" >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="toSee(scope.row)">
                查看
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  @click="toChange(scope.row)"
                  class="h-tableLink h-btn"
                  v-if="isTimeEqual(scope.row)"
              >
                修改
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="printDetail(scope.row.id)">
                导出明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
      <!--数据展示end-->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import updownfile from "@/utils/updownfile";
export default {
  data(){
    return{
      // 展开折叠筛选
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      q:{
        agentCode: null, //经销商编码
        agentName: null, //经销商名称
        channelCode: null, //渠道
        conveneName: null,//召开人
        weekTime: null,//创建日期
        weekMonth: null,
        provinceCode: null,//省
        pageNo:1,
        pageSize: 10,
        total: 0,

      },
      monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
      tableData: [],
      currentTime: ''
    }
  },
  methods:{
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    query(){
      console.log(this.q,'查询条件')
      weeklyMeetingApi.selectPage(this.q).then(res=>{
        console.log(res)
        this.q.total = res.total
        this.tableData = res.records
      })
    },
    //检索
    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },
    resetData(){
      this.q = {
        pageNo:1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    //新增网络运营会
    createdMeeting() {
      this.$router.push({path: "/agent/addWeeklyMeeting"});
    },
    //查看详情
    toSee(row){
      this.$router.push({path: "/agent/seeWeeklyMeeting",query:{id:row.id}});
    },
    //修改--当天申请的可以修改
    toChange(row){
      console.log(row)
      this.$router.push({path: "/agent/changeWeeklyMeeting",query:{id:row.id}});
    },
    //判断当前时间是否是创建那天
    isTimeEqual(row){
      return moment(new Date(row.cdate)).format('YYYY-MM-DD') == this.currentTime
    },
    printDetail(x){
      updownfile.down('/api/swyl/v1/demo/bscNetworkMeeting/downloadExcelDetail',{id:x},"get");
    },
    //批量导出
    exportExcel(){
      let params = {
        agentCode:this.q.agentCode,
        agentName:this.q.agentName,
        channelCode:this.q.channelCode,
        conveneName:this.q.conveneName,
        weekTime:this.q.weekTime,
        provinceCode:this.q.provinceCode,
      }
      weeklyMeetingApi.downloadExcelList(params).then(res=>{
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `运营会列表.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  },
  created() {
    this.currentTime = moment(new Date()).format('YYYY-MM-DD')
    this.query()
  },
  activated() {
    this.query()
  }
}
</script>
<style scoped>
</style>
